// Role: Patient
// Description: Report viewer. Used as home page for patient role.
import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Route, Switch } from 'react-router-dom';
import { PageWrapper, Row, Col } from 'virtues-bootstrap';

import HistoryList from 'containers/HistoryList/PatientHistoryList';
import EmptyPage from 'components/EmptyPage';
import ReportView from 'containers/RolePatient/ReportView';

const EmptyReportPage = () => <EmptyPage text="reports.selectReportInSidebar" />;

const ReportPage = ({ match }) => (
  <PageWrapper>
    <Row>
      <Col xs={4}>
        <HistoryList />
      </Col>
      <Col xs={8}>
        <Switch>
          <Route exact path={match.url} component={EmptyReportPage} />
          <Route path={`${match.url}/:id`} component={ReportView} />
        </Switch>
      </Col>
    </Row>
  </PageWrapper>
);

ReportPage.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default ReportPage;
